module.exports = __webpack_public_path__ + "static/media/time-icon.c386babd.webp";